import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <ol>
                <li>
                  Bharath, S., Rajan, K. S., &amp; Ramachandra, T. V. (2014).
                  Status and future transition of rapid urbanizing landscape in
                  central Western Ghats&mdash;CA-based approach. ISPRS Annals of
                  Photogrammetry, Remote Sensing &amp; Spatial Information
                  Sciences,2(8), 69&ndash;75
                </li>
                <li>
                  Bonan, G. B. (2008). Forests and climate change: forcings,
                  feedbacks, and the climate benefits of forests. science,
                  320(5882), 1444-1449.
                </li>
                <li>
                  Bonan, G. B. (2008). Forests and climate change: forcings,
                  feedbacks, and the climate benefits of forests. science,
                  320(5882), 1444-1449.
                </li>
                <li>
                  Breiman, L. (2001). Random forests. Machine learning, 45(1),
                  5-32.{" "}
                  <a href="https://doi.org/10.1023/A:1010933404324">
                    https://doi.org/10.1023/A:1010933404324
                  </a>
                  .
                </li>
                <li>
                  Breiman, L., Friedman, J. H., Olshen, R. A., &amp; Stone, C.
                  J. (2017). Classification and regression trees. Routledge.
                </li>
                <li>
                  Deepakshi Babbar, G. Areendran, Mehebub Sahana, Kiranmay
                  Sarma, Krishna Raj and Akhil Sivadas (2021). Assessment and
                  prediction of carbon sequestration using Markov chain and
                  InVEST model in Sariska Tiger Reserve, India. Journal of
                  Cleaner Production, Volume 278, 2021, 123333, ISSN 0959-6526
                </li>
                <li>
                  Directorate of Census Operations, Karnataka (2011) Census
                  district handbook. Karnataka, district Chikmagalur
                </li>
                <li>
                  District Disaster Management Plan (DDMP) for Chikkamagaluru
                  District Accessed 2019-20
                  https://ksdma.karnataka.gov.in/storage/pdf-files/Chikkamagaluru%20DDMP%202019-20.pdf.
                  Accessed September 2023
                </li>
                <li>
                  Eisfelder, C., Kuenzer, C., &amp; Dech, S. (2012). Derivation
                  of biomass information for semi-arid areas using
                  remote-sensing data.&nbsp;International Journal of Remote
                  Sensing,&nbsp;33(9), 2937-2984.
                </li>
                <li>
                  Houghton, R. A., &amp; Hackler, J. L. (1999). Emissions of
                  carbon from forestry and land‐use change in tropical
                  Asia.&nbsp;Global Change Biology,&nbsp;5(4), 481-492.
                </li>
                <li>
                  Houghton, R. A., House, J. I., Pongratz, J., van der Werf, G.
                  R., DeFries, R. S., Hansen, M. C., Le Que&acute;re&acute;, C.,
                  &amp; Ramankutty, N. (2012). Carbon emissions from land use
                  and land-cover change. Biogeosciences, 9(12), 5125&ndash;5142.
                </li>
                <li>
                  (2018). Indian Meterological Department, Hydrometerological
                  Services, Minist. Earth Sci. Gov. India. http://www.
                  imd.gov.in/pages/services_hydromet.php. Accessed Sept 2023.
                </li>
                <li>
                  (2018). Karnataka State Natural Disaster Monitoring Centre,
                  Gov. Karnataka.{" "}
                  <a href="http://dmc.kar.nic.in/default.asp.%20Accessed%20Sept%202023">
                    http://dmc.kar.nic.in/default.asp. Accessed Sept 2023
                  </a>
                  .
                </li>
                <li>
                  Lal, R. (2003). Global potential of soil carbon sequestration
                  to mitigate the greenhouse effect.&nbsp;Critical reviews in
                  plant sciences,&nbsp;22(2), 151-184.
                </li>
                <li>
                  Lal, R. (2008). Carbon sequestration. Philosophical
                  Transactions of the Royal Society B: Biological Sciences,
                  363(1492), 815-830
                </li>
                <li>
                  Lal, R., Negassa, W., &amp; Lorenz, K. (2015). Carbon
                  sequestration in soil.&nbsp;Current Opinion in Environmental
                  Sustainability,&nbsp;15, 79-86.
                </li>
                <li>
                  Leuschner, C., Moser, G., Hertel, D., Erasmi, S., Leitner, D.,
                  Culmsee, H., ... &amp; Schwendenmann, L. (2013). Conversion of
                  tropical moist forest into cacao agroforest: consequences for
                  carbon pools and annual C sequestration.&nbsp;Agroforestry
                  Systems,&nbsp;87, 1173-1187.
                </li>
                <li>
                  Lillesand, T. M., Kiefer, R. W., &amp; Chipman, J. W. (2014).
                  Remote sensing and image interpretation. New York: Wiley.
                </li>
                <li>
                  Mengist, W., Soromessa, T., &amp; Feyisa, G. L. (2023).
                  Responses of carbon sequestration service for landscape
                  dynamics in the Kaffa biosphere reserve, southwest
                  Ethiopia.&nbsp;Environmental Impact Assessment
                  Review,&nbsp;98, 106960.
                </li>
                <li>
                  Nagaraja, B.C., Hemanjali A.M., Somashekar R.K. &amp; Pramod
                  K. (2014) Assessment of Forest Encroachment in Chikamagaluru
                  District of Western Ghats using RS and GIS. International
                  Journal of Remote Sensing &amp; Geoscience (IJRSG), Volume 3,
                  Issue 6, Nov. 2014.
                </li>
                <li>
                  National Informatics Centre, Ministry of Electronics &amp;
                  Information Technology, Government of India
                  https://chikkamagaluru.nic.in/en/about-district/ Accessed
                  September 2023
                </li>
                <li>
                  (2019). Climate Data Guide. https://climatedataguide.uca
                  r.edu/data-type/gridded-obs. Accessed Sept 2023.
                </li>
                <li>
                  Pascal, J.P. (1986). &nbsp;Explanatory booklet on the Forest
                  Map of South India&nbsp;-&nbsp;Sheets: Belgaum-Dharwar-Panaji;
                  Shimoga; Mercara-Mysore. Published by the Karnataka Forest
                  Department and the French Institute of Pondicherry.&nbsp;Inst.
                  fr. Pondich&eacute;ry, trav. sec. sci. tech. Hors
                  s&eacute;rie&nbsp;18.
                </li>
                <li>
                  Raha, D., Dar, J. A., Pandey, P. K., Lone, P. A., Verma, S.,
                  Khare, P. K., &amp; Khan, M. L. (2020). Variation in tree
                  biomass and carbon stocks in three tropical dry deciduous
                  forest types of Madhya Pradesh, India. Carbon Management,
                  11(2), 109-120.
                </li>
                <li>
                  Ramachandra, T. V., &amp; Bharath, S. (2019). Global warming
                  mitigation through carbon sequestrations in the Central
                  Western Ghats.&nbsp;Remote Sensing in Earth Systems
                  Sciences,&nbsp;2, 39-63.
                </li>
                <li>
                  Ramachandra, T. V., &amp; Bharath, S. (2020). Carbon
                  sequestration potential of the forest ecosystems in the
                  Western Ghats, a global biodiversity hotspot.&nbsp;Natural
                  Resources Research,&nbsp;29(4), 2753-2771.
                </li>
                <li>
                  Ramachandra, T. V., &amp; Bharath, S. (2021). Carbon footprint
                  of Karnataka: Accounting of sources and sinks.&nbsp;Carbon
                  Footprint Case Studies: Municipal Solid Waste Management,
                  Sustainable Road Transport and Carbon Sequestration, 53-92.
                </li>
                <li>
                  Ramachandra, T. V., Aithal, B. H., &amp; Sreejith, K. (2015).
                  GHG footprint of major cities in India.&nbsp;Renewable and
                  Sustainable energy reviews,&nbsp;44, 473-495.
                </li>
                <li>
                  Ravindranath, N. H., &amp; Ostwald, M. (2007). Carbon
                  inventory methods: handbook for greenhouse gas inventory,
                  carbon mitigation and roundwood production projects (Vol. 29).
                  Springer Science &amp; Business Media.
                </li>
                <li>
                  Ravindranath, N. H., Somashekhar, B. S., &amp; Gadgil, M.
                  (1997). Carbon flow in Indian forests. Climatic change, 35,
                  297-320.
                </li>
                <li>
                  Reichle, D. E. (2023). The global carbon cycle and climate
                  change: scaling ecological energetics from organism to the
                  biosphere. Elsevier.
                </li>
                <li>
                  Riitters, K., Wickham, J., O&rsquo;Neill, R., Jones, B., &amp;
                  Smith, E. (2000). Global-scale patterns of forest
                  fragmentation.&nbsp;Conservation ecology,&nbsp;4(2).
                </li>
                <li>
                  Roy, P. S., Ramachandran, R. M., Paul, O., Thakur, P. K.,
                  Ravan, S., Behera, M. D., ... &amp; Kanawade, V. P. (2022).
                  Anthropogenic land use and land cover changes&mdash;A review
                  on its environmental consequences and climate
                  change.&nbsp;Journal of the Indian Society of Remote
                  Sensing,&nbsp;50(8), 1615-1640.
                </li>
                <li>
                  Swamy, H. R. (1992). Organic productivity, nutrient cycling
                  and small watershed hydrology of natural forests and
                  monoculture plantations in Chikmagalur district, Karnataka
                  (No. CONF-9102202-). John Wiley and Sons, Inc., New York, NY
                  (United States).
                </li>
                <li>
                  The State Gazetteer Advisory Committee (1983) Karnataka State
                  Gazetteer, Part II. Government of Karnataka Publication THRG
                  (2019). Terrestrial Hydrology Research Group, Global
                  Meteorological Forcing Dataset for land surface modeling,
                  Princeton University.
                </li>
                <li>
                  Tyrrell, M. L., Ross, J., &amp; Kelty, M. (2012). Carbon
                  dynamics in the temperate forest.&nbsp;Managing forest carbon
                  in a changing climate, 77-107.
                </li>
                <li>
                  UNFCC 2021. COP26: Together for our planet.{" "}
                  <a href="https://www.un.org/en/climatechange/cop26%20accessed%20on%20September%202023">
                    https://www.un.org/en/climatechange/cop26 accessed on
                    September 2023
                  </a>
                </li>
                <li>
                  Ussiri, D. A., &amp; Lal, R. (2017).&nbsp;Carbon sequestration
                  for climate change mitigation and adaptation&nbsp;(pp.
                  287-325). Cham: Springer International Publishing.
                </li>
                <li>
                  van de Ven, D. J., Capellan-Pere&acute;z, I., Arto, I.,
                  Cazcarro, I., de Castro, C., Patel, P., &amp; Gonzalez-Eguino,
                  M. (2021). The potential land requirements and related land
                  use change emissions of solar energy. Scientific Reports, 11,
                  2907. https://doi.org/10.1038/ s41598-021-82042-5
                </li>
                <li>
                  van Noordwijk, M., Cerri, C., Woomer, P. L., Nugroho, K.,
                  &amp; Bernoux, M. (1997). Soil carbon dynamics in the humid
                  tropical forest zone.&nbsp;Geoderma,&nbsp;79(1-4), 187-225.
                </li>
                <li>
                  Yoro, K. O., &amp; Daramola, M. O. (2020). CO2 emission
                  sources, greenhouse gases, and the global warming effect. In
                  Advances in carbon capture (pp. 3-28). Woodhead Publishing.
                </li>
                <li>
                  Zeppetello, L. R. V., Parsons, L. A., Spector, J. T., Naylor,
                  R. L., Battisti, D. S., Masuda, Y. J., &amp; Wolff, N. H.
                  (2020). Large scale tropical deforestation drives extreme
                  warming.&nbsp;Environmental Research Letters,&nbsp;15(8),
                  084012.
                </li>
              </ol>
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
